import React from "react";
import { ClearingPartnerContainer } from "../../../containers";

const ClearingPartner = (props) => {
  return <ClearingPartnerContainer {...props} />;
};
export default ClearingPartner;
